import React from "react";
import Image from "next/image";
import { RecipesWrap, FirstHalf, SecondHalf, Text, List, Item, Title, Heading, Link } from "./styled";

const Recipes = () => {
  const email = "mailto:creators@joinfoody.com";
  return (
    <RecipesWrap>
      <FirstHalf>
        <Image src={`/images/recipes.png`} alt="Recipes" layout="fill" objectFit="contain" quality={100} />
      </FirstHalf>
      <SecondHalf>
        <Title>
          Focus on what you're <Link noUnderline>best at</Link>.
        </Title>
        <Text fontSize="18" width="530">
          Running a business means wearing a lot of hats. We know that, which is why we handle all the technology,
          design, administration and logistics so you can focus on what matters - creating great recipes and engaging
          with your customers.
        </Text>
        <Heading color="grayDark" fontSize="18">
          Support
        </Heading>
        <Text width="290">We take care of customer support 24/7, as well as supporting you day to day.</Text>
        <Heading color="grayDark" fontSize="18">
          Education
        </Heading>
        <Text width="350">Robust creator resources to help you make, market and sell the best content possible.</Text>
        <Heading color="grayDark" fontSize="18">
          Technology
        </Heading>
        <Text width="444">
          We are constantly working to add new services and techology to make our platform more enjoyable for customers
          and more powerful for Creators. Have an idea? We'd love to hear it! Send us a note at:
          <Link href={email}> creators@joinfoody.com</Link>
        </Text>
        <Heading color="grayDark" fontSize="18">
          Logistics
        </Heading>
        <Text fontSize="18" width="516">
          Running an online business takes more than just great content. We take care of the business logistics so that
          you don't have to.
        </Text>
        <List fontSize="18">
          <Item>Credit card processing, fraud, chargebacks, refunds.</Item>
          <Item>Local & regional sales tax compliance on digital goods.</Item>
          <Item>Local & regional privacy regulation compliance (GDPR, CCPA, etc).</Item>
          <Item>Storage and backup of digital content.</Item>
        </List>
      </SecondHalf>
    </RecipesWrap>
  );
};

export default Recipes;
